import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { AdminPageHeader, Button } from "@/components/ui";

export function UsuariosHeader({ total }: { total: number }) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Usuarios"
      description={`Listado de usuarios del portal con sus roles, áreas asignadas y organizaciones permitidas · ${total} total.`}
      actions={
        <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
          Volver
        </Button>
      }
    />
  );
}
